"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m10.02 18 6-6-6-6-1.41 1.41L13.19 12l-4.58 4.59z"
}), 'NavigateNextTwoTone');